/* eslint-disable no-undef */
import { Facets } from '../../modules/Facets';
import { MainMenu } from '../../modules/MainMenu';
import { ViewToggler } from '../../modules/ViewToggler';
import { tns } from 'tiny-slider';
import { Page } from '../Page';
import { Common } from './common';

export class AllPages extends Page {
    public static render(): void {
        MainMenu.init();
        Facets.init();

        AllPages._moveFacetsToViewHeader();
        AllPages._generateAllViewTogglers();
        AllPages._resizeRegisteredSymbols();
        AllPages._animationParagraph();
        AllPages._animationHistory();
        AllPages._animationRowIcons();
        AllPages._animationImage();
        AllPages._hideHeaderScroll();
        AllPages._calculateBannerContentTranslation();
        AllPages._searchClothing();
        AllPages._openInfoModal();
        AllPages._menuLanguage();
        AllPages._initSlider();
        AllPages._menuComercialNet();
        AllPages._vendorsCollapsible();
        AllPages._vendorsInfoWindowCollapsible();
        AllPages._vendorsMapListeners();
        AllPages._regulationsAccordion();
        AllPages._helpModal();
        AllPages._breadcrumbInNotDefaultHeaderPages();
        // AllPages._videoModal();
        AllPages._circleTextImageMoreInfo();
        AllPages._openModalWonderGrip();
        AllPages._openDesplegableSeo();
        AllPages._numberCounter();
        Common._openDesplegableFichaRopa();
        AllPages._oneTrustTranslateItemMenu();
        AllPages._animateResourceButtons();

        setTimeout(() => {
            AllPages._webformModal();
            AllPages._formValidateCaptcha();
        }, 500);
    }

    private static _generateAllViewTogglers(): void {
        const togglers = document.querySelectorAll<HTMLDivElement>('.view-toggler');

        for (const toggler of Array.from(togglers)) {
            ViewToggler.create(toggler);
        }
    }

    private static _moveFacetsToViewHeader(): void {
        // TOOD: Find a better way.
        const searchHeader = document.querySelector<HTMLElement>('.view-search__header__facets');
        const facetRegion = document.querySelector<HTMLElement>('.region-exposed-filters');
        const searchRegion = document.querySelector<HTMLElement>('.region-search');

        // Moves the factes to the search header view region
        if (searchHeader) {
            if (facetRegion) {
                searchHeader.appendChild(facetRegion);
            }

            if (searchRegion) {
                searchHeader.appendChild(searchRegion);
            }
        }
    }

    private static _resizeRegisteredSymbols(): void {
        Array.from(document.querySelectorAll('strong'))
            .filter((div) => div.innerHTML.includes('®'))
            .forEach((div) => {
                const split = div.innerText.split(' ');

                div.innerHTML = split.map((text) => {
                    if (text !== '®') {
                        return text;
                    }

                    return `<span class="registered">${text}</span>`;
                }).join(' ');
            });
    }

    private static _animationParagraph(): void {
        AllPages.animateParagraph();

        $(window).scroll(function () {
            AllPages.animateParagraph();
        });
    }

    private static animateParagraph(): void {
        const window_y = $(window).scrollTop() + $(window).height();
        const paragraph = $('.paragraph--type--imagen-texto-flotante, .paragraph--type--texto-fondo-degradado');

        paragraph.each(function () {
            const top_paragraph = $(this).offset().top - ($(this).height() / 2);

            if (window_y >= top_paragraph) {
                $(this).addClass("visible");
            }
        });
    }

    private static _animationHistory(): void {

        AllPages.animateHistory();

        $(window).scroll(function () {
            AllPages.animateHistory();
        });
    }

    private static animateHistory(): void {
        const window_y = $(window).scrollTop() + $(window).height();
        const history = $('.node--type-eje-cronologico-historia');

        history.each(function () {
            const top_history = $(this).offset().top + ($(this).height() / 3);
            const image = $(this).find('.image');
            const text = $(this).find('.text');

            if (window_y >= top_history) {
                image.addClass("visible");
                text.addClass("visible");
            }
        });
    }

    private static _animationRowIcons(): void {
        const row = $('.paragraph--type--row-icons');
        if (row.length == 0) return;
        $(window).on('resize scroll', function () {
            const elementTop = row.offset().top;
            const elementBottom = elementTop + row.outerHeight();
            const viewportTop = $(window).scrollTop() ?? 0;
            const viewportBottom = viewportTop + $(window).height();

            if (elementBottom > viewportTop && elementTop < viewportBottom) {
                row.addClass("visible");
            }
        });
    }

    private static _animationImage(): void {
        const images = $('.paragraph--type--image.animation');
        if (images.length == 0) return;

        $(window).on('resize scroll', function () {
            images.each(function () {
                if (AllPages._checkIfElementIsVisible($(this))) {
                    $(this).addClass('visible');
                }
            })

        });
    }

    private static _checkIfElementIsVisible(element: JQuery): Boolean {
        const elementTop = element.offset().top;
        const elementBottom = elementTop + element.outerHeight();
        const viewportTop = $(window).scrollTop() ?? 0;
        const viewportBottom = viewportTop + $(window).height();

        if (elementBottom > viewportTop && elementTop < viewportBottom) {
            return true;
        }
        return false;
    }

    private static _hideHeaderScroll(): void {
        const header = $('header.header');
        const main = $('#main-wrapper');

        let position = $(window).scrollTop();
        $(window).on('scroll', function () {
            let st = $(window).scrollTop();
            if (st > position) {
                header.addClass("scroll-down");
                header.addClass("no-transparent");
                main.addClass("scroll-down");
            } else {
                header.removeClass("scroll-down");
                if (st > 0) {
                    header.addClass('no-transparent');
                }
                else {
                    header.removeClass('no-transparent');
                    main.removeClass("scroll-down");
                }
            }

            position = st;
        });
    }

    private static _calculateBannerContentTranslation(): void {
        const bannerHeader = $('div.header, div.header_page');
        if (bannerHeader.length == 0) return;

        const bannerImage = bannerHeader.find('.image, .video, .blur');
        bannerImage.height(bannerHeader.height());
        const introBlue = $('.paragraph--type--intro-blue');

        if (introBlue.length == 0) return;
        bannerImage.css('position', 'fixed');

        AllPages._translate(bannerImage, introBlue);

        $(window).on('scroll', function () {
            AllPages._translate(bannerImage, introBlue);
        });

        $(window).on('resize', function () {
            bannerImage.height(bannerHeader.height());
            AllPages._translate(bannerImage, introBlue);
        });
    }

    private static _translate(bannerImage: JQuery, introBlue: JQuery): void {
        const heightVindow = $(window.top).height();
        const percentage = introBlue.innerHeight() * 100 / heightVindow;

        let top = $(window).scrollTop();
        top = top * percentage / 100;
        bannerImage.css('transform', 'translate(0,-' + top + 'px');
    }

    private static _searchClothing() {
        const search_clothing = $('.search-clothing');
        if (search_clothing.length == 0) return;

        const input = search_clothing.find('input[name="ref"]');
        const result = search_clothing.find('.result');
        const loading = search_clothing.find('.loading');

        let xhr = null;

        input.on('keypress', function () {

            result.empty();
            loading.show();

            if (xhr != null) {
                xhr.abort();
            }

            if (input.val() == '') {
                loading.hide();
                result.removeClass('visible');

                return;
            }

            const lang = drupalSettings.language;
            const url = `/m/search/${lang}/ropa/1/` + input.val();

            xhr = $.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',

                success: function (json) {
                    const products = json.products;

                    if (products == null || products == undefined) return;

                    const close_result = $('<div></div>');
                    close_result.addClass('close_results');
                    const close = $('<span></span>');
                    close.text('Cerrar');

                    const close_icon = $('<span></span>');
                    close_icon.addClass('material-icons');
                    close_icon.text('close');

                    close_result.append(close);
                    close_result.append(close_icon);

                    const content_nodes = $('<div></div>');
                    content_nodes.addClass('list_results');

                    Object.keys(products).forEach(function (id, index) {
                        const node = products[id];
                        const title = node.title;
                        const description = node.description;
                        const image = node.image;
                        const url = node.url;

                        const content_node = $('<div></div>');

                        const image_node = $('<div></div>');
                        image_node.addClass('image');
                        const img_node = $('<img />');
                        img_node.attr('src', image);

                        image_node.append(img_node);

                        const text_node = $('<div></div>');
                        text_node.addClass('text');
                        const title_node = $('<p></p>');
                        title_node.addClass('title');
                        title_node.text(title);

                        const link_node = $('<a></a>');
                        link_node.attr('href', url);
                        link_node.addClass('row-link');

                        const description_node = $('<p></p>');
                        description_node.addClass('description');
                        description_node.text(description);

                        text_node.append(title_node);
                        text_node.append(description_node);
                        text_node.append(link_node);

                        content_node.append(image_node);
                        content_node.append(text_node);

                        content_nodes.append(content_node);
                    });

                    result.append(close_result);
                    result.append(content_nodes);
                    result.addClass('visible');

                    close_result.on('click', function () {
                        result.removeClass('visible');
                    });

                    loading.hide();
                },
            });
        });

        result.on('click', function (e) {
            e.stopPropagation();
        });

        $('body').on('click', function () {
            result.removeClass('visible');
        });
    }

    private static _openInfoModal() {

        const modals = $('.modal-info');
        const opensModal = $('.open-modal');

        if (modals.length == 0 && opensModal.length > 0) {
            return;
        }

        opensModal.on('click', function () {
            modals.removeClass('visible');
            const parent = $(this).parent();
            const modal = parent.find('.modal-info');
            modal.addClass('visible');
        });

        const closeModal = $('.close-modal');
        closeModal.on('click', function () {
            const modal = $(this).closest('.modal-info');
            modal.removeClass('visible');
        });
    }

    private static _menuLanguage(): void {
        $('body').on('click', function () {
            $('.language-switcher-language-url .nav > ul > li > ul').removeClass('open');
        });

        $('body').on('click', '.language-switcher-language-url .nav > ul > li > span', function (e) {
            e.stopPropagation();

            const menu = $(this).closest('li').find('> ul');
            menu.toggleClass('open');
        });

        $('body').on('click', '.language-switcher-language-url .nav > ul > li > ul', function (e) {
            e.stopPropagation();
        });
    }

    private static _initSlider(): void {
        if ($('.view-gloves-per-solution .view-unformatted__row').length > 0) {
            tns({
                "container": ".view-gloves-per-solution .view-unformatted__row",
                "items": 3,
                "center": true,
                "mouseDrag": true,
                "slideBy": "page",
                "swipeAngle": false,
                "speed": 400,
                "fixedWidth": 380,
                "controls": true,
                "controlsPosition": "bottom",
                "controlsText": ['<span class="logo"></span>', '<span class="logo"></span>'],
                "nav": false,
                "responsive": {
                    "1024": {
                        "fixedWidth": 429,
                    },
                },
            });
        }

        if ($('.view-banner-blog .view-unformatted__row').length > 0) {
            tns({
                "container": ".view-banner-blog .view-unformatted__row",
                "items": 1,
                "center": true,
                "mouseDrag": true,
                "slideBy": "page",
                "swipeAngle": false,
                "speed": 400,
                "autoplay": false,
                "autoplayTimeout": 5000,
                "controls": false,
                "nav": true,
                "navPosition": 'bottom',
            });
        }

        if ($('#catalogos-sectores .taxonomy-downloads .view-unformatted__row').length > 0) {
            tns({
                "container": "#catalogos-sectores .taxonomy-downloads .view-unformatted__row",
                "items": 3,
                "loop": false,
                "mouseDrag": true,
                "slideBy": "page",
                "swipeAngle": false,
                "controls": true,
                "controlsPosition": "bottom",
                "controlsText": ['<span class="logo"></span>', '<span class="logo"></span>'],
                "nav": false,
                "responsive": {
                    "0": {
                        "items": 1,
                    },
                    "768": {
                        "items": 2,
                    },
                    "992": {
                        "items": 3,
                    },
                },
            });
        }
    }

    private static _menuComercialNet() {
        const team = $('#team');
        if (team.length == 0) return;

        const list_anchors = team.find('.field--name-field-column-1').find('.paragraph--type--text');

        const member_team = team.find('.paragraph--type--block-reference');
        member_team.each(function () {
            const title_team = $(this).find('.field--name-field-title').text();
            const id = $(this).attr('id');
            const button = document.createElement("a");
            button.setAttribute("href", '#' + id);
            button.innerHTML = title_team + '';
            list_anchors.append(button);
        })
    }

    private static _vendorsCollapsible() {
        const vendorsZone = $('.commercialZones');

        if (vendorsZone.length === 0) {
            return;
        }

        vendorsZone.parent().on('click', 'h3', (e: JQuery.ClickEvent) => {
            const target = $(e.currentTarget);
            target.toggleClass('active');
            const panel = target.next('.commercialZones');
            panel.slideToggle();
        });
    }

    private static _vendorsInfoWindowCollapsible() {
        const vendorsMap = $('.view-mapa-comerciales');

        if (vendorsMap.length === 0) {
            return;
        }

        vendorsMap.find('.geolocation-location').each(function () {
            const item = $(this);
            const body = item.find('.views-field-body')?.text()?.replaceAll('\n', '') ?? '';
            const fax = item.find('.views-field-field-fax')?.text()?.replaceAll('\n', '') ?? '';

            if (body.length) {
                item.find('.views-field-field-correo-electr-nico').after(`<p class="more-info">${Drupal.t('Más información')}</p>`);
            } else {
                item.find('.views-field-body').remove();
            }

            if (fax.length === 0) {
                item.find('.views-field-field-fax').remove();
                item.find('.more-info').css('margin-top', '20px');
            }
        });

        vendorsMap.on('click', '.more-info', (e: JQuery.ClickEvent) => {
            const moreInfo = $(e.currentTarget).parent().find('.views-field-body');
            moreInfo.slideToggle();
        });
    }

    private static _vendorsMapListeners() {
        const vendorsMap = $('#mapa_comerciales');
        const vendorsZones = $('.commercialZones');

        if (vendorsMap.length === 0 || vendorsZones.length === 0) {
            return;
        }

        vendorsZones.find('li').on('click', (e: JQuery.ClickEvent) => {
            const target = e.currentTarget;

            const coordinates = $(target).find('.geolocation-latlng').text().split(',');

            if (coordinates.length === 0) {
                return;
            }

            const lat = parseFloat(coordinates[0]);
            const lng = parseFloat(coordinates[1]);

            const currentPageMap = Drupal.geolocation.maps[0].googleMap;
            currentPageMap.setCenter(new google.maps.LatLng(lat, lng));
            currentPageMap.setZoom(14);

            $.each(Drupal.geolocation.maps[0].mapMarkers, function (index, currentMarker) {
                const lat_marker = currentMarker.position.lat();
                const lng_marker = currentMarker.position.lng();

                if (lng == lng_marker && lat == lat_marker) {
                    google.maps.event.trigger(currentMarker, "click");
                }
            });

            vendorsZones.find('li').removeClass('selected');
            $(target).addClass('selected');

            return false;
        });
    }

    private static _regulationsAccordion() {
        const listadoNormativas = $('.listado-normativas');

        if (listadoNormativas.length === 0) {
            return;
        }

        listadoNormativas.find('.item').on('click', '.titulo', function (e) {
            e.stopImmediatePropagation();
            const item = $(this);

            item.toggleClass('opened');
            item.next().slideToggle();

        });

        listadoNormativas.find('.leyenda .contenido').on('click', 'a', function () {
            const rel = $(this).attr('rel');
            const section = $(`div[data-rel="${rel}"]`);

            $('html, body').animate({
                scrollTop: $(section).offset().top
            });

            section.find('.titulo').addClass('opened');
            section.find('.titulo').next().slideDown();
        });
    }

    private static _helpModal() {
        const modal = $('.help-modal');

        if (modal.length === 0) {
            return;
        }

        const helpButton = $('#block-menuprincipalderecha .openHelpModal');
        const closeButton = modal.find('.close');

        helpButton.attr('href', 'javascript: void(0);');

        helpButton.on('click', function () {
            modal.toggleClass('hide');
        });

        closeButton.on('click', function () {
            modal.addClass('hide');
        });
    }

    private static _breadcrumbInNotDefaultHeaderPages() {
        const breadcrumb = $('.breadcrumb-nav');
        let previousContainer = undefined;

        if ($('body.node-page:not(.default-header)').length === 0 || $('body.node-page:not(.no-transparent)').length === 0) {
            if ($('.intro_blue').length) {
                previousContainer = $('.intro_blue');
            }
            breadcrumb.insertAfter(previousContainer);
            return;
        }

        if ($('.header_page').length) {
            previousContainer = $('.header_page');
        }

        if ($('.field--name-field-intro').length) {
            previousContainer = $('.field--name-field-intro');
        }

        if (previousContainer === undefined) {
            return;
        }

        breadcrumb.insertAfter(previousContainer);
    }

    private static _videoModal() {
        const container = $('.listado-videos .withColorboxVideo');
        if (container.length === 0) {
            return;
        }

        container.colorbox({
            iframe: true,
            width: '80%',
            height: '80%',
            title: false,
            close: '<em class="material-icons">close</em>',
            current: Drupal.t("{current} of {total}"),
            fixed: true,
            returnFocus: false,
        });
    }

    private static _circleTextImageMoreInfo() {
        const title = $('.page-circle-text .field--name-field-parrafos #circle .paragraph--type--text');

        title.on({
            mouseenter: function (event) {
                $(this).parent().find('.field--name-field-text').css('display', 'block');
            },
            mouseleave: function () {
                $(this).parent().find('.field--name-field-text').css('display', 'none');
            }
        });
    }

    private static _webformModal() {
        let block = undefined;
        let button = undefined;

        if ($('.page-home').length > 0) {
            block = $('[id^="block-newsletter"]');
            button = $('.page-home .newsletter-block .paragraph--type--button a');
        }
        else if ($('.page-juba-ssp').length > 0) {
            block = $('[id^="block-asesoramientopersonalizado"]');
            button = $('.page-juba-ssp .paragraph--type--row-grey .paragraph--type--button a');
        }
        else if ($('.node-guantes').length > 0) {
            block = $('[id^="block-technical-consultation"]');
            button = $('.node-guantes .technical-consultation .info .button a');

        } else if ($('.exportar-guantes').length > 0) {
            block = $('[id^="block-formularioexpuestoexportar-guantespage-1"]');
            button = $('.exportar-guantes .view-exportar-guantes__header__headings .button a');
        } else {
            return;
        }

        if (block.length === 0) {
            return;
        }

        const closeButton = block.find('.close');
        const closeButtonExportGuantes = block.find('.form-submit');

        button.on('click', function (e) {
            e.preventDefault();

            block.toggleClass('tinted');
            block.toggleClass('hide');
            $('body').addClass('stop-scrolling');
        });

        closeButton.on('click', function (e) {
            e.preventDefault();

            block.addClass('hide');
            block.removeClass('tinted');
            $('body').removeClass('stop-scrolling');
        });

        closeButton.on('click', function (e) {
            e.preventDefault();

            block.addClass('hide');
            block.removeClass('tinted');
            $('body').removeClass('stop-scrolling');
        });
    }

    private static _formValidateCaptcha() {
        $('form').submit(function (e) {
            if ($(this).find('.g-recaptcha').length > 0 && grecaptcha.getResponse().length == 0) {
                e.preventDefault();
                $('.recaptcha_error').remove();
                $('.g-recaptcha').append(`<p class="recaptcha_error"style="color:red">${Drupal.t('Rellene el Captcha')}</p>`);
            }
        })
    }

    private static _openModalWonderGrip() {

        function openModal(modalElement) {
            modalElement.removeClass('hide').addClass('show');
            $('body').addClass('no-scroll');
        }

        function closeModal(modalElement) {
            modalElement.removeClass('show').addClass('hide');
            $('body').removeClass('no-scroll');
        }

        function setupModalEvents(triggerElement, modalElement) {
            triggerElement.on('click', function () {
                openModal(modalElement);
            });

            const closeButton = modalElement.find('.close-button');
            closeButton.on('click', function () {
                closeModal(modalElement);
            });
        }

        const technologytm = $('.technologytm');
        const modalTechnologytm = $('.modal-technologytm');
        setupModalEvents(technologytm, modalTechnologytm);

        const dualiner = $('.dualiner');
        const modalDualiner = $('.modal-dualiner');
        setupModalEvents(dualiner, modalDualiner);

        const hdml = $('.hdml');
        const modalHdml = $('.modal-hdml');
        setupModalEvents(hdml, modalHdml);

        const beeSeries = $('.bee-series');
        const modalBeeSeries = $('.modal-bee-series');
        setupModalEvents(beeSeries, modalBeeSeries);

        const performance = $('.performance');
        const modalPerformance = $('.modal-performance');
        setupModalEvents(performance, modalPerformance);

    }

    private static _openDesplegableSeo() {
        const body = $('body');
        if (body.hasClass('taxonomy')) {
            body.find('.paragraph--type--desplegable-seo').appendTo(body.find('#main .view-taxonomy-term'));
        }

        const buttonShow = body.find('.field--name-field-abrir-desplegable-seo');
        const desplegable = body.find('.field--name-field-texto-desplegable-seo');

        if (desplegable.length == 0) {
            const divPadre = buttonShow.parent();
            divPadre.css('display', 'none');
            return;
        }

        buttonShow.on('click', function () {
            if (desplegable.hasClass('opened')) {
                desplegable.removeClass('opened');
                buttonShow.text(Drupal.t('Ver más'));

                return;
            }

            desplegable.addClass('opened');
            buttonShow.text(Drupal.t('Ver menos'));
        });

    }

    private static _numberCounter() {
        let counters = document.querySelectorAll(".counter");
        if (counters.length === 0) {
            return;
        }

        let duration = 2000;
        let stepDuration = 10;

        const callback = (entries) => {
            if (entries[0].isIntersecting) {
                observer.unobserve(entries[0].target);
                counters.forEach(counter => {
                    let target = parseInt(counter.getAttribute('data-target'));
                    let incrementValue = target / Math.ceil(duration / stepDuration);
                    let currentValue = 0;
                    let interval = setInterval(() => {
                        if (currentValue < target) {
                            currentValue += incrementValue;
                            counter.textContent = Math.ceil(currentValue);
                        } else {
                            clearInterval(interval);
                            counter.textContent = target;
                        }
                    }, stepDuration);
                });
            }
        };

        const observer = new IntersectionObserver(callback, { threshold: 0.9 });
        observer.observe(counters[0]);
    }

    private static _oneTrustTranslateItemMenu() {

        const menuItems = $("#block-piedepagina .navbar-nav .nav-item .ot-sdk-show-settings");
        const originalText = menuItems.map(function() {
            return $(this).text().trim();
        }).get();

        menuItems.each(function(index) {
            setTimeout(() => {
                $(this).text(originalText[index]);
            }, 1000);
        });
    }

    private static _animateResourceButtons() {
        const buttons = $('.field--name-field-descripcion-cabecera .section-buttons a');

        buttons.on('click', function(e) {
            e.preventDefault();
            const section = $(this).attr('href');

            if (section && $(section).length) {
                $('html, body').animate({
                    scrollTop: $(section).offset()!.top - 200
                }, 300);
            }
        });
    }
}
